import { common as en_common } from "../en/common";

/** common — RU slice (55 keys). */
export const common: Record<keyof typeof en_common, string> = {
  time_seconds_short: "{time}с",
  time_minutes_short: "{time}м",
  time_hours_short: "{time}ч",
  time_days_short: "{time}д",
  time_weeks_short: "{time}нед",
  time_months_short: "{time}мес",
  time_years_short: "{time}г",
  time_ago_text: "{time} назад",
  common_app_name: "Linqx",
  common_copy: "Копировать",
  common_close: "Закрыть",
  common_skip: "Пропустить",
  common_submit: "Отправить",
  common_continue: "Продолжить",
  common_message_copied: "Скопировано.",
  common_error_access_denied: "Доступ запрещён",
  common_error_title: "Ошибка",
  common_save: "Сохранить",
  common_create: "Создать",
  common_delete: "Удалить",
  common_not_found_placeholder_title: "Страница не найдена",
  common_not_found_placeholder_description:
    "Извини, мы не смогли найти страницу, которую ты ищешь.",
  common_not_found_placeholder_button: "На главную",
  common_network_error_title: "Проверь подключение",
  common_network_error_description:
    "С твоим сетевым подключением что-то временно не так. Убедись, что ты в интернете, и перезагрузи приложение.",
  common_network_error_reload_button: "Перезагрузить",
  common_select_photo: "Загрузить фото",
  common_take_photo: "Сделать фото",
  common_choose_from_library: "Выбрать из галереи",
  common_unable_to_save_file: "Не удалось сохранить файл",
  common_camera_permission_denied:
    "Для съёмки нужен доступ к камере. Включите его в Настройках.",
  common_message_changes_saved: "Изменения успешно сохранены.",
  signin_btn: "Войти",
  submit_btn: "Отправить",
  save: "Сохранить",
  about_activation_finish:
    "Нажимая «Войти», ты соглашаешься с {terms} и {privacy}",
  about_activation_finish_privacy: "Политикой конфиденциальности",
  about_activation_finish_terms: "Условиями использования",
  connecting: "Подключение..",
  signout: "Выйти",
  no_results: "Ничего не найдено",
  intro_title: "Linqx",
  intro_description:
    "Открой для себя новый способ знакомиться с новыми друзьями",
  error_alert_ok: "Ок",
  error_alert_title: "Ошибка",
  error_try_again: "Попробовать снова",
  internet_connection_error:
    "Нет соединения, проверь настройки подключения к интернету.",
  about_app_privacy: "Политика конфиденциальности",
  about_app_terms_privacy: "Условия и конфиденциальность",
  about_app_terms: "Условия использования",
  tab_item_messages: "Недавние чаты",
  tab_item_geo_search: "Гео-поиск",
  tab_item_profile: "Профиль",
  tab_item_events: "События",
  common_cancel: "Отмена",
  common_loading: "Загрузка...",
  common_block_confirm_title: "Заблокировать этого человека?",
  common_block_confirm_message:
    "Вы больше не будете видеть друг друга. Отсюда это не отменить.",
  common_block_confirm_confirm: "Заблокировать",
  common_block_error: "Не удалось заблокировать. Попробуй ещё раз.",
  common_block: "Заблокировать",
  common_report: "Пожаловаться",
  common_linq: "LINQ",
  common_nope: "NOPE",
  report_reason_label: "Причина",
  report_reason_spam: "Спам",
  report_reason_scam: "Мошенничество или обман",
  report_reason_abuse: "Оскорбления или неприемлемый контент",
  report_reason_harassment: "Домогательства или травля",
  report_reason_other: "Другое",
  report_message_label: "Сообщение (необязательно)",
  report_message_placeholder:
    "Добавь детали, которые помогут нам рассмотреть жалобу.",
  report_submit: "Отправить",
  report_submitting: "Отправка…",
  report_pick_reason: "Выбери причину.",
  report_no_bridge: "Мост жалоб недоступен.",
  report_standalone: "Запущено без хоста Linqx — отправка отключена.",
  report_target_label: "Жалоба на:",
};
